export default __webpack_public_path__ + "static/cli_okmarket-6e1d69a938d1e181f2b0698f84bacc08.png";